import { render, staticRenderFns } from "./UniversalTags.vue?vue&type=template&id=64a7159f&scoped=true"
import script from "./UniversalTags.vue?vue&type=script&lang=js"
export * from "./UniversalTags.vue?vue&type=script&lang=js"
import style0 from "./UniversalTags.vue?vue&type=style&index=0&id=64a7159f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7159f",
  null
  
)

export default component.exports